// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';
import { toggleModal } from '../../../storage/actions/modalsActions';
import { localCurrencySettings } from '../../../utils/constans';

const Header = ({
  profile, toggleModal,
}) => {
  const { update } = useIntercom();
  useEffect(() => {
    update({
      alignment: 'right',
      horizontal_padding: 16,
      vertical_padding: 16,
      user: profile.name,
      email: profile.email,
      phone: profile.phone,
      created_at: new Date(),
      customAttributes: {
        name: profile.name,
        company_name: profile?.company?.name,
        user_id: profile.unique_id,
        w9_user_id: profile.unique_id,
        user_type: profile.userType,
      },
    });
    return () => {
      update({
        alignment: 'right',
        horizontal_padding: 16,
        vertical_padding: 16,
      });
    };
  }, [profile, update]);

  const funds = useMemo(() => (
    profile?.balance.total_balance
      ? Number(profile.balance.total_balance - (profile.balance.on_hold || 0))
        .toLocaleString('en-US', localCurrencySettings)
      : '$0.00'
  ), [profile]);

  return (
    <section className="dashboard-hero" aria-hidden="false">
      <span className="dashboard-hero-bg" aria-hidden="true" />
      <span className="dashboard-hero-tint" aria-hidden="true" />
      <span className="dashboard-hero-curve" aria-hidden="true" />
      <header className="dashboard-header">
        <div className="header-greeting">
          <span>
            Hey <strong>{profile.name}</strong>, welcome back!
          </span>
          {profile.userType === 'client' && (
            <span className="header-funds">
              Funds Available: <strong>{funds}</strong>
            </span>
          )}
        </div>
        <div className="header-user">
          <button className="header-avatar profile_btn" aria-label="profile" onClick={() => toggleModal(true, 'profile')} type="button">
            <img src={profile.image || 'https://www.w3schools.com/css/img_avatar.png'} alt="" />
          </button>
          <div className="header-user-info">
            <span className="header-user-name">{profile.name}</span>
            <span className="header-user-role">{profile.userType}</span>
          </div>
        </div>
      </header>
    </section>
  );
};

const mapStateToProps = state => ({
  profile: state.profile,
});

export default connect(
  mapStateToProps,
  { toggleModal },
)(withRouter(Header));
